module.exports = __webpack_public_path__ + "img/[捂脸哭].83a8b945.svg";